import { render } from "./QuestionScreen.vue?vue&type=template&id=84e0f26a"
import script from "./QuestionScreen.vue?vue&type=script&lang=js"
export * from "./QuestionScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__